import { postMessageToAndroid, postMessageToIOS } from 'appBridge/bridge'

export function closeExtensionWindow () {
  postMessageToIOS('close')
  postMessageToAndroid('close')
}
